<template>
  <button
    :class="{ selected }"
    :disabled="disabled"
    @click="onClick">
    <slot></slot>
    <div v-if="arrow" class="arrow">
      <span></span>
      <span></span>
    </div>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick (e) {
      setTimeout(() => {
        this.$emit('click')
      }, 200)
    }
  }
}
</script>

<style scoped lang="scss">
button {
  display: inline-block;
  height: 6.0rem;
  padding: 0 6.0rem;
  border: none;
  border-radius: 0;
  font-family: 'Akrobat', Helvetica, Arial, sans-serif;
  font-size: 2.7rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  line-height: 6.6rem;
  white-space: nowrap;
  color: $color-white;
  background-color: $color-orange;
  clip-path: polygon(
    5% 0, /* left top */
    100% 0, /* right top */
    95% 100%, /* right bottom */
    0 100% /* left bottom */
  );
  transition: background-color 100ms;
  outline: 0;
  cursor: pointer;

  &:hover {
    background-color: lighten($color-orange, 5%);
  }

  &:active {
    transform: translateY(.2rem);
  }

  .arrow {
    position: relative;
    float: right;
    margin: 0 0 0 2rem;
    width: 0;
    height: 100%;
    overflow: visible;

    span {
      position: absolute;
      top: 50%;
      display: block;
      width: 1.5rem;
      height: .2rem;
      transform-origin: 0 50%;
      background-color: $color-white;

      &:first-child {
        transform: translate(0, -1rem) rotate(45deg);
      }

      &:last-child {
        transform: translate(0, 1rem) rotate(-45deg);
      }
    }
  }
}
</style>
